import { useState, MouseEvent } from 'react'
import AddSharpIcon from '@mui/icons-material/AddSharp'
import Button from '@mui/material/Button'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import { t } from '@lingui/core/macro'

export interface NameOption {
  value: string
  display_name: string
}

interface Props {
  nameOptions: NameOption[]
  handleOptionClick: (value: NameOption) => void
}

export const InsertButton = ({ nameOptions, handleOptionClick }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const onOptionSelect = (value: NameOption) => {
    if (nameOptions.length == 1) {
      handleClose()
    }
    handleOptionClick(value)
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="outlined"
        disabled={nameOptions.length == 0}
        onClick={handleClick}
        style={{ lineHeight: 3.3, marginLeft: 15 }}
      >
        <AddSharpIcon />
        {t`Insert`}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {nameOptions.map(nameOption => (
          <Typography
            key={nameOption.value}
            sx={{ p: 2 }}
            onClick={() => {
              onOptionSelect(nameOption)
            }}
          >
            {nameOption.display_name}
          </Typography>
        ))}
      </Popover>
    </div>
  )
}
